<mat-form-field mat-input-height-large-label>
  <mat-label matTooltipPosition="above" [matTooltip]="matchedValue?.translationid | translate">{{
    matchedValue?.translationid | translate
  }}</mat-label>
  <input
    data-at-remote-diagnostics-edit-value="number"
    [attr.data-at-value]="matchedValue?.value"
    gtm="onNumberInput"
    gtmAction="Vdd number edit value"
    gtmCategory="diagnosticsPage"
    [gtmOn]="['change', 'focus', 'blur']"
    matInput
    type="number"
    [formControl]="numberFormControl"
    [value]="matchedValue?.value"
    [min]="minValue"
    [max]="maxValue"
    [step]="step"
    (change)="valueChange($event)"
    fieldTextContentTooltip
  />
  <span data-at-unit matSuffix mat-suffix-outside>{{ matchedValue?.unit }}</span>
  <mat-error *ngIf="numberFormControl.hasError('min')" class="validation-error">
    {{ minValue }}
    {{ 'DIAGNOSTICS.EDIT_NUMBER.MIN' | translate }}</mat-error
  >
  <mat-error *ngIf="numberFormControl.hasError('required')" class="validation-error">{{
    'DIAGNOSTICS.EDIT_NUMBER.REQUIRED' | translate
  }}</mat-error>
  <mat-error *ngIf="numberFormControl.invalid" class="validation-error">{{
    'DIAGNOSTICS.EDIT_NUMBER.ERROR' | translate
  }}</mat-error>
</mat-form-field>
